import React, {Component} from "react";

class StakeLOTT extends Component{

    constructor(props){
        super(props);
        this.state = {
            
        }
    }

    render(){
        return(
            <div className="breadcrumb-area">
                <div>
                    <h1>Stake LOTT</h1>
                </div>
                
                <div className="project-widget">
                    <LottCard />
                    <LottCard />
                    <LottCard />
                </div>
            </div>
        );
    }
}

export default StakeLOTT;

export function LottCard() {
    return(
            <div className="project-card sec-bg br-10 stake-lott-card">
                <h3 className="prim-txt">6 Months Vault</h3>
                    <br />
                <p>MAX lock per Vault 200000 LOTT</p>
                    <br />
                <p className="small-txt sec-txt">Stake LOTT tokens for 6 Months to earn up to <span className="prim-txt">45% APY</span> </p>
                    <br />
                <div className="widget-card prim-bg"></div>
                    <br />
                <div className="balance-lott-card widget-card prim-bg bold-text">
                    Balance 0 Lott
                </div>
                    <br />
                <div className="balance-lott-card widget-card prim-bg bold-text">
                    Get LoTT
                </div>
                <div className="lott-capacity">
                    <p className="small-txt">Vault Capacity: 139, 241 LOTT</p>
                    <div className="progress-bar">
                        <div></div>
                    </div>
                </div>
                <div className="total-stocked">
                    <div>
                        <p className="small-txt sec-txt bold-text">Total Staked: 60,786 LOTT</p>
                    </div>
                </div>
            </div>
    )
}